// React
import React, {Component} from "react";
import {connect} from "react-redux";
// Routing
import {withRouter} from "react-router-dom";
// Components
import NotFound from "views/NotFound/application";
// Containers
import UserEdit from "views/Users/application/user_edit";

class RouteEdit extends Component {

    // method that selects which layout should display.
    setContent(layout, id) {
        if (layout === "users") {
            return <UserEdit id={id}/>;
        } else {
            return <NotFound/>;
        }
    }

    render() {
        const {match} = this.props;
        return (
            <React.Fragment>
                <div className={"man-content"}>
                    {this.setContent(match.params.type, match.params.id)}
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        data: state
    };
};

const connect_ = connect(
    mapStateToProps
)(RouteEdit);

export default withRouter(connect_);